import { useEditor } from '@candulabs/craft';
import React from 'react';

import { ValueBox, ValueGroup, ValueToggle } from '@candu-ai/craft/ui';
import { useRefresh } from 'craft/hooks/useRefresh';
import { FlowSaveProgress } from 'craft/resolvers/Flow/types';

interface SaveProgressToggleProps {
  nodeId?: string;
  label?: string;
}
export const SaveProgressToggle = ({ nodeId, label = 'Flow' }: SaveProgressToggleProps) => {
  const {
    actions: { setCustom },
  } = useEditor();
  const [refresh] = useRefresh();

  const { query } = useEditor();
  const flowNode = query.node(nodeId).get();

  const isPermanentStore =
    flowNode?.data?.custom?.custom?.saveProgress === FlowSaveProgress.Permament;

  const onTogglePermanent = () => {
    if (flowNode?.id) {
      setCustom(flowNode?.id, (custom) => {
        if (isPermanentStore) {
          // eslint-disable-next-line no-param-reassign
          custom.custom = {};
          return;
        }
        // eslint-disable-next-line no-param-reassign
        custom.custom = { saveProgress: FlowSaveProgress.Permament };
      });
      refresh();
    }
  };

  return (
    <ValueGroup>
      <ValueBox label={`Save user progress through ${label}`}>
        <ValueToggle isActive={isPermanentStore} onClick={onTogglePermanent} />
      </ValueBox>
    </ValueGroup>
  );
};
